import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {Photo, Sector} from "../../models/data.model";
import {DataProvider} from "../../providers/data/data";
import {PhotosViewerPage} from "../photos-viewer/photos-viewer";
import {PhotosRoutesViewerPage} from "../photos-routes-viewer/photos-routes-viewer";

@IonicPage()
@Component({
  selector: 'page-sector',
  templateUrl: 'sector.html',
})
export class SectorPage {

  siteId : number;
  sectorId: number;
  photos: Photo[] = [];

  constructor(public navParams: NavParams,
              public navCtrl: NavController,
              private data: DataProvider) {
    this.siteId = navParams.get('siteId');
    this.sectorId = navParams.get('sectorId');
    if (this.isSectorOffline()) {
      this.data.getPhotosOffline(this.getSector().photos)
        .then(photos64 => {
          this.photos = [...photos64];
        })
    }
    else {
      this.photos = this.getSector().photos.map(photo => {
        return {
          name: photo,
          url: DataProvider.getPhotoUrl(photo, false)
        }
      });
    }
  }

  protected getSector(): Sector {
    return this.data.getSector(this.siteId, this.sectorId);
  }

  protected openPhotoGallery() {
    this.navCtrl.push(PhotosViewerPage, {
      photos: this.photos,
    }).catch();
  }

  protected clickText(event: Event) {
    const element: HTMLElement = <HTMLElement>event.target;
    if (element.nodeName != "IMG") return;
    const photo: Photo = {
      name: "photo",
      url: (<HTMLImageElement>element).src
    };
    this.navCtrl.push(PhotosViewerPage, {
      photos: [photo]
    }).catch();
  }

  protected openPhotosPaths() {
    this.navCtrl.push(PhotosRoutesViewerPage, {
      siteId: this.siteId,
      sectorId: this.sectorId,
      photos: this.photos
    }).catch();
  }

  protected isSectorOffline() {
    return this.data.isSectorOffline(this.sectorId);
  }

  protected downloadSector() {
    this.data.downloadSector(this.siteId, this.sectorId);
  }

}



// WEBPACK FOOTER //
// ./src/pages/sector/sector.ts